import type { TextBlockComponent } from "../../types";
import { isParagraphHtml } from "../../utils/paragraphHtml";
import { paragraphHtmlToSafeHtml } from "../../utils/inlineIcons";

function renderParagraph(p: string, i: number) {
  if (isParagraphHtml(p)) {
    return (
      <p
        key={i}
        className="rich-paragraph-block"
        dangerouslySetInnerHTML={{ __html: paragraphHtmlToSafeHtml(p) }}
      />
    );
  }
  return <p key={i}>{p}</p>;
}

/** Text block renderer with paragraphs and sanitized HTML support. */
export function TextBlockRenderer({ component }: { component: TextBlockComponent }) {
  const { paragraphs } = component.content;
  return (
    <section className="text-base xl:text-lg text-[#0F2849] space-y-6 rich-paragraph-block">
      {(paragraphs ?? []).map(renderParagraph)}
    </section>
  );
}


